import Stack from '@mui/material/Stack'

import { GridCellParams } from '@mui/x-data-grid'

import { MerchantLogo, Text } from '@mxenabled/mxui'

interface PayeeCellProps extends GridCellParams {
  excludedText: string
}

const PayeeCell = (params: PayeeCellProps) => {
  return (
    <Stack alignItems="center" direction="row" gap={8}>
      <MerchantLogo
        categoryGuid={params.row.top_level_category_guid || ''}
        merchantGuid={params.row.merchant_guid || ''}
      />
      <Stack alignItems="flex-start" direction="column">
        <Text tabIndex={params.tabIndex} variant="body2">
          {params.row.payee}
        </Text>
        {params.row.is_hidden && <Text variant="caption">{params.excludedText}</Text>}
      </Stack>
    </Stack>
  )
}

export default PayeeCell
